(function localePickerScroll() {
  // The locale-picker dropdowns (snippets/locale-picker.liquid) are CSS-only
  // <details> panels. The country list holds every Curaprox market, so it is
  // capped in height and scrolls. When it opens we want the currently-selected
  // market centred in view instead of the panel opening scrolled to the top.
  //
  // The `toggle` event does NOT bubble, so we listen in the capture phase —
  // the same global-delegation approach as assets/auto-close-details.js.
  document.addEventListener(
    'toggle',
    function (event) {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;
      if (!details.classList.contains('locale-picker__details')) return;

      const list = details.querySelector('.locale-picker__list');
      const current = list && list.querySelector('.locale-picker__option--current');
      if (!list || !current) return;

      // Read layout after the panel has painted, then centre the current option.
      requestAnimationFrame(function () {
        list.scrollTop = current.offsetTop - (list.clientHeight - current.offsetHeight) / 2;
      });
    },
    true
  );
})();
